const muiTypographyStyles: any = {
  fontFamily: '"Inter", sans-serif',
  h1: {
    fontWeight: 600,
    color: 'var(--black)',
    fontSize: '64px',
    lineHeight: '78px',
    fontStyle: 'normal',
    textTransform: 'capitalize',
    '@media (max-width: 1715px)': {
      fontSize: '40px'
    }
  },
  h2: {
    fontSize: '40px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  h3: {
    fontSize: '34px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  h4: {
    fontSize: '32px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  h5: {
    fontSize: '30px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  h6: {
    fontSize: '28px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  subtitle1: {
    fontSize: '24px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  subtitle2: {
    fontSize: '22px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  subtitle3: {
    fontSize: '20px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  subtitle4: {
    fontSize: '18px',
    fontWeight: 600,
    fontStyle: 'normal',
    color: 'var(--dark-2)',
    lineHeight: 'normal'
  },
  body1: {
    fontSize: '16px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'var(--dark-1)',
    lineHeight: 'normal'
  },
  body2: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'var(--dark-1)',
    lineHeight: 'normal'
  },
  caption: {
    fontSize: '12px',
    fontWeight: 500,
    fontStyle: 'normal',
    color: 'var(--dark-1)',
    lineHeight: 'normal'
  },
  overline: {
    fontSize: '10px',
    fontWeight: 400,
    fontStyle: 'normal',
    color: 'var(--dark-3)',
    lineHeight: 'normal',
    textTransform: 'none'
  }
};

export default muiTypographyStyles;
